<template>
  <component :is="tag" class="gkui-popup" :style="style" @click="handleClick" @mouseenter="handleShow" @mouseleave="handleHide">
    <slot />
    <PopupBox
      :inner="true"
      :visible="show"
      :reference="popper"
      :position="position"
      :offset="{left: left, top: top}"
      :color="color"
      :disabled="disabled"
      :delay="delay"
      :arrow="arrow"
      :label="label"
    >
      <template slot="content">
        <slot name="content" />
      </template>
    </PopupBox>
  </component>
</template>

<script>
import VueTypes from 'vue-types'
import BaseHtmlTag from '../base/BaseHtmlTag'
import PopupBox from './PopupBox'

import props from './props'

export default {
  name: 'gk-popover',
  components: {
    BaseHtmlTag,
    PopupBox
  },
  props: Object.assign({
    tag: VueTypes.string.def('span'),
    trigger: VueTypes.oneOf(['hover', 'click', 'custom']).def('hover'),
    visible: VueTypes.bool.def(false),
    zIndex: VueTypes.number.def(1),
    once: VueTypes.bool.def(true),
    auto: VueTypes.bool.def(false),
    left: VueTypes.oneOfType([Number, String]).def(0),
    top: VueTypes.oneOfType([Number, String]).def(0)
  }, props),
  data () {
    return {
      show: this.visible,
      popper: null,
      timer: null
    }
  },
  computed: {
    style () {
      return this.show ? {zIndex: this.zIndex} : {}
    }
  },
  watch: {
    show (show) {
      if (show && this.auto) {
        setTimeout(() => {
          this.show = false
        }, 1000)
      }
      this.$emit('visible', show)
    },
    visible (show) {
      this.show = show
    }
  },
  created () {
  },
  mounted () {
    this.popper = this.$el
  },
  methods: {
    handleClick (e) {
      this.$emit('click')

      if (this.trigger !== 'click') {
        return
      }

      if (this.timer) {
        clearTimeout(this.timer)
      }

      if (this.show) {
        this.show = false
        return
      }

      this.show = true

      if (this.once && !this.auto) {
        this.$nextTick(() => {
          this.timer = setTimeout(() => {
            document.addEventListener('click', () => {
              this.show = false
            }, {once: true})
          }, 50)
        })
      }
    },
    handleShow () {
      this.$emit('mouseenter')

      if (this.trigger !== 'hover') {
        return
      }

      this.show = true
    },
    handleHide () {
      this.$emit('mouseleave')

      if (this.trigger !== 'hover') {
        return
      }

      this.show = false
    }
  }
}
</script>
